import styled from 'styled-components';

export default styled.div`
  width: 100%;

  .chart-container {
    position: relative;
    height: 250px;
    
    div {
      max-height: 250px;
    }
  }
`;
